export default "__VITE_ASSET__CKj7VivW__"